import React, { useCallback } from 'react';
import cn from 'classnames';

import { formatZipCode } from './helpers';
import TextInputFormik, { TextInputFormikProps } from './TextInputFormik';
import styles from './ZipCodeInputFormik.less';

type Props = Omit<TextInputFormikProps, 'allowedRegex' | 'transformValue'>;

const REGEX = /^[\d-]*$/;
/**
 * A zipcode number input that auto-formats as the user types.
 */
const ZipCodeInputFormik: React.FC<Props> = ({ className, ...props }) => {
  const transformValue = useCallback((value: string): string => formatZipCode(value), []);

  return (
    <TextInputFormik
      className={cn(styles.input, className)}
      maxLength={10}
      {...props}
      allowedRegex={REGEX}
      transformValue={transformValue}
    />
  );
};

export default ZipCodeInputFormik;
